import styled from "styled-components";

export const LojasContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1071px;
    margin: 3rem auto;
    gap: 20px;
`;

export const LojasTitle = styled.h2`
    text-align: center;
    margin: 20px 0;
    color: var(--c-brand-accent);
    font-weight: 900;
    font-family: "Lato", sans-serif;
    width: 100%;
    font-size: 30px;

    @media (max-width: 768px) {
        font-size: 28px;
    }
`;

export const LojasWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const LojasGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    border-top: 1.5px lightgray solid;
    border-left: 1.5px lightgray solid;
    @media (max-width: 1024px) and (min-width: 768px) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
`;

export const LojaCard = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1.5px solid lightgray;
    border-bottom: 1.5px solid lightgray;
    padding: 5px;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.3s ease;
    width: 123px;
    height: 123px;
    position: relative;
    overflow: hidden;

    &:hover {
        box-shadow: inset 0 0 10px var(--c-brand-accent-soft);
    }
    @media (max-width: 768px) {
        width: 100px;
        height: 100px;
    }
    @media (max-width: 1024px) and (min-width: 769px) {
        width: 150px;
        height: 150px;
    }
`;

export const LojaCashback = styled.span`
    position: absolute;
    bottom: 5px; 
    left: 50%;
    transform: translateX(-50%);
    color: var(--c-brand-accent-soft);
    font-size: 14px;
    font-weight: 700;
    border-radius: 6px;
    padding: 2px 6px;
    text-align: center;
    pointer-events: none; 
    @media (max-width: 768px) {
        font-size: 10px;
        bottom: 4px;
    }
`;


export const LojaImagem = styled.img`
    height: auto;
    max-width: 100%;
    object-fit: contain;

    @media (max-width: 768px) {
        width: 100px;
    }
`;

export const LoadingText = styled.p`
    text-align: center;
    color: #555;
    font-size: 1rem;
    margin: 2rem 0;
    font-family: "Lato", sans-serif;
`;
